import styled from 'styled-components';

export const ButtonGradient = styled.button`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '50px'};
  background: ${(props) => props.theme.colors.primary.gradient};
  border-radius: ${(props) => props.borderRadius || '5px'};
  border: none;
  color: ${(props) => props.theme.colors.background.white};
  font-size: ${(props) => props.fontSize || '16px'};
  font-weight: ${(props) => props.fontWeight || 'bold'};
  margin-bottom: ${(props) => props.marginBottom || 0};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

export const ButtonSolid = styled.button`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '30px'};
  background: ${(props) => props.theme.colors.primary.solid};
  border-radius: ${(props) => props.borderRadius || '5px'};
  border: none;
  color: ${(props) => props.theme.colors.background.white};
  font-size: ${(props) => props.fontSize || '14px'};
  font-weight: ${(props) => props.fontWeight || '400'};
  margin-bottom: ${(props) => props.marginBottom || '0'};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  &:hover {
    opacity: ${(props) => (props.disabled ? 1 : 0.8)};
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

export const ButtonCustomColor = styled(ButtonSolid)`
  background: ${(props) => props.bgColor || props.theme.colors.primary.solid};
  color: ${(props) => props.color || props.theme.colors.background.white};
`;

export const ButtonOutline = styled.button`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '44px'};
  cursor: pointer;
  font-size: ${(props) => props.fontSize || '14px'};
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => props.theme.colors.primary.main};
  color: ${(props) => props.theme.colors.primary.main};
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  margin: ${(props) => props.margin || '0'};

  &:disabled {
    border-color: ${(props) => props.theme.colors.text.grey};
    color: ${(props) => props.theme.colors.text.grey};
    cursor: not-allowed;
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;
